import React, { Component } from 'react';
import styles from './Tab.module.css';
import Area from '../Area';
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faProjectDiagram, faShareAlt, faBacon,faTag,faTable, faSearch,faMap,faCoffee,faSitemap,faCube,faCheck, faDrawPolygon ,faCircle,faInfo,faSquare,faSquareFull, faPlus, faBox,faCogs,faDotCircle,faDatabase,faDiceD6, faBullseye,faBoxOpen,faCheckSquare } from '@fortawesome/free-solid-svg-icons'


library.add(faProjectDiagram,faShareAlt,faBacon,faTag,faTable,faMap,faSearch,faCheckSquare,faSitemap,faCheck,faCircle,faDrawPolygon,faInfo,faSquare,faSquareFull,faPlus,faCogs,faBullseye,faDotCircle, faDiceD6,faDatabase,faBox,faBoxOpen, faCube,faCoffee,faCube);



class Tab extends Component {
  state = { selectedIndex: 0 };
  

  componentDidUpdate(prevProps) {
    let tabSelectionSubscription = this.props.tabSelectionSubscription;
    if (tabSelectionSubscription) {
      if (prevProps.pubsub[tabSelectionSubscription] !== this.props.pubsub[tabSelectionSubscription]) {
        let index = this.props.pubsub[tabSelectionSubscription];
        this.setState({ selectedIndex: index });
      }
    }
  }


  onTabClick = index => {
    let tabSelectionSubscription = this.props.tabSelectionSubscription;
    if (tabSelectionSubscription) {
      this.props.publish(tabSelectionSubscription, index);
    } else {
      this.setState({ selectedIndex: index });
    }
  };

  render() {
    let mode = this.props.mode;
    return (
      <div className={styles.main + (mode === 'edit' ? '' : ' ' + styles.viewMode)}>
        
        <div className={styles.tabs}> 
       
          {this.props.tabs.map((tab, index) => {
            let selected = index === this.state.selectedIndex;
            var icons= this.props.icons;
           
            return (
              <div
                key={index}
                className={styles.tab + (selected ? ' ' + styles.selected : '')}
                onClick={() => this.onTabClick(index)}>
                   { icons!=null &&  <FontAwesomeIcon  icon={icons[index]} size="xs" transform="down-0; left-4" /> }
                {tab}
              </div>
              
            );
          })}
        </div>
             
        {
        this.props.tabs.map((tab, index) => {
          let areaConfig = this.props.areas[index] || {};
          
          let selected = index === this.state.selectedIndex;
           
                  
          return (
            <div key={index} className={styles.areaContainer} style={{ display: selected ? 'flex' : 'none' }}>
              <Area
                {...this.props}
                index={index}
                config={areaConfig}
                onChange={this.props.onChange}
                withinSelectedTab={selected}
              />
            </div>
          );
                
        })}
      </div>
    );
  }
}

export default Tab;
